import { compose } from 'recompose'
import TitleWrapper from './TitleWrapper'

export default compose()(TitleWrapper)

